/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Fulfillment_Waiting_On_ResendInputs */

const en_fulfillment_waiting_on_resend = /** @type {(inputs: Fulfillment_Waiting_On_ResendInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on Logistics · instruction refused · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on Logistics · instruction refused · since {since}" |
*
* @param {Fulfillment_Waiting_On_ResendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fulfillment_waiting_on_resend = /** @type {((inputs: Fulfillment_Waiting_On_ResendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Waiting_On_ResendInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fulfillment_waiting_on_resend(inputs)
});